import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { useUserStore } from '@/store/modules/user';
import { getAccessToken, getPoolNo } from '@/utils/auth';
import remainingRouter from './modules/remaining'

// 创建路由实例
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL), // createWebHashHistory URL带#，createWebHistory URL不带#
  strict: true,
  routes: remainingRouter as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = `${to.meta.title} - ${import.meta.env.VITE_APP_TITLE}`;
  }
  // 登录页特殊处理
  if (to.path === '/login') {
    next();
    return;
  }
  // 检查是否需要认证
  if (to.meta.requiresAuth && !getAccessToken()) {
    const userStore = useUserStore()
    var poolNo = ''
    const poolNoCache = getPoolNo()
    if (userStore.getPoolNo) {
      poolNo = userStore.getPoolNo;
    } else if (poolNoCache) {
      poolNo = poolNoCache;
    }
    var query = {}
    if (poolNo) {
      query = {
        poolNo: poolNo,
        ...to.query
      }
    } else {
      query = to.query;
    }
    next({
      path: '/login',
      query
    });
    return;
  }
  next();
});

export default router;
